import { AssignmentsV3Document } from '@/store/v2';
import { ApolloError, useQuery, ApolloQueryResult } from '@apollo/client';

import { Space } from '@/types/learning/learning-catalog';
import { AssignmentsV3QueryResult, AssignmentV3 } from '@/store/assignments/types';
import { AssignmentV3Status, AssignmentV3Type } from '@/store/assignments/typesOther';

type UseBaseAssignmentsHook = (query: {
  userIds: number[];
  spaces: readonly Space[] | null;
  status: AssignmentV3Status;
  type?: AssignmentV3Type;
  skip?: boolean;
}) => {
  data: AssignmentV3[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => Promise<ApolloQueryResult<AssignmentsV3QueryResult>>;
};

export const useBaseAssignments: UseBaseAssignmentsHook = ({ userIds, spaces, status, skip, type }) => {
  const spacesIds = spaces?.map((space) => space.id) ?? null;

  const { data, loading, error, refetch } = useQuery<AssignmentsV3QueryResult>(AssignmentsV3Document, {
    skip,
    variables: {
      selectHomepage: true,
      type,
      userIdIN: userIds,
      spacedIdsIN: spacesIds,
      pagination: {
        limit: -1,
        page: 1,
      },
      status,
    },
  });

  return {
    data: data?.assignmentsV3?.data,
    loading,
    error,
    refetch,
  };
};
